var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.op] || "-",
          backUrl: "/marketing/free-redeem/list",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c("el-alert", {
            staticClass: "mt20",
            attrs: {
              title:
                "注：参与免费兑的商品金额需要与配置的优惠券券面额相等，否则可能出现异常",
              type: "warning",
              closable: false,
            },
          }),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "批次名称：", prop: "batchName" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "100",
                              "show-word-limit": "",
                              placeholder: "请输入批次名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.batchName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "batchName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.batchName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "优惠券ID：", prop: "couponId" } },
                        [
                          _c(
                            "div",
                            { on: { click: _vm.selectCoupon } },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: { readonly: "" },
                                model: {
                                  value: _vm.formValidate.couponId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "couponId", $$v)
                                  },
                                  expression: "formValidate.couponId",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      !_vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "发放数量：",
                                prop: "totalCount",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 1,
                                  step: 1,
                                  disabled: _vm.isDisabled,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                  placeholder: "请输入发放数量",
                                },
                                model: {
                                  value: _vm.formValidate.totalCount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "totalCount",
                                      $$v
                                    )
                                  },
                                  expression: "formValidate.totalCount",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注：", prop: "remark" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.remark,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "remark",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.checkPermi([
                    "platform:free-redeem:save",
                    "platform:free-redeem:update",
                  ])
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isDisabled,
                              expression: "!isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formValidate")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }